export default __webpack_public_path__ + "static/media/ios-arrow-forward.74a28ecb.svg";